"use strict";
// Variable to check if an animation is already in progress
var isModalAnimationInProgress = false;
// Initalize modal event listeners
document.addEventListener('DOMContentLoaded', function () {
    var modalLinks = document.querySelectorAll('[data-reveal-id]:not([data-reveal-id=""])');
    // Register event listeners to every modalLink
    for (var i = 0; i < modalLinks.length; i++) {
        // Get the link element
        var modalRevealId = modalLinks[i].dataset.revealId;
        if (modalRevealId) {
            window.initModalClickListener(modalLinks[i], modalRevealId);
        }
    }
});
// Attach click listener to link and copy modal to the end of the document in order to be on top of everything when open
window.initModalClickListener = function (link, revealId, showModal) {
    // If init already done, don't do anything
    if (link.dataset.isModalHandlerAttached) {
        return;
    }
    // mark link click handler attached
    link.dataset.isModalHandlerAttached = true;
    // Add click event listener to the link element
    link.addEventListener('click', modalToggle.bind(null, revealId), true);
    var modal = document.getElementById(revealId);
    // appending the modal to the body element to prevent overlap issues
    document.body.appendChild(modal);
    // Add click event listener for the modal close button
    if (modal) {
        // Default hiding modals
        modal.classList.add('modal-hidden');
        var modalClose = modal.querySelector('a.close-reveal-modal');
        if (modalClose) {
            modalClose.addEventListener('click', modalToggle.bind(null, revealId), true);
        }
    }
    // show modal after init
    if (showModal) {
        modalToggle(revealId);
    }
};
// Reveal or close modal
function modalToggle(revealId, event) {
    // only prevent navigation if we were directly called by event listener
    if (event) {
        event.preventDefault();
    }
    if (isModalAnimationInProgress) {
        return;
    }
    isModalAnimationInProgress = true;
    var animationDuration = 400; // Should be equal to SCSS variable $animation-duration in modal.scss
    var modal = document.getElementById(revealId);
    if (window.getComputedStyle(modal).opacity == 0) {
        // Prepare the modal background element
        var modalBgElement = document.createElement('DIV');
        modalBgElement.classList.add('reveal-modal-bg', 'modal-hidden');
        modalBgElement.addEventListener('click', modalToggle.bind(null, revealId), true);
        // Insert the background element
        modal.parentElement.insertBefore(modalBgElement, modal);
        var modalBg = modal.previousElementSibling;
        // Reveal the modal
        modal.style.display = 'inline-block';
        modalBg.style.display = 'block';
        // Setting a small timeout for the class removal so the animation starts on displayed elements
        setTimeout(function () {
            modal.classList.remove('modal-hidden');
            modalBg.classList.remove('modal-hidden');
            // Disable scrolling
            document.body.style.overflow = 'hidden';
            isModalAnimationInProgress = false;
        }, 10);
    }
    else {
        // Hide the modal
        modal.classList.add('modal-hidden');
        var modalBgHide = modal.previousElementSibling;
        modalBgHide.classList.add('modal-hidden');
        setTimeout(function () {
            modal.style.display = 'none';
            modalBgHide.parentNode.removeChild(modalBgHide);
            // Stop media playing coming from iframe or video
            var iframes = modal.querySelectorAll('iframe');
            var videos = modal.querySelectorAll('video');
            for (var i = 0; i < iframes.length; i++) {
                iframes[i].src += '';
            }
            for (var i = 0; i < videos.length; i++) {
                videos[i].pause();
            }
            // Enable scrolling
            document.body.style.overflow = 'auto';
            isModalAnimationInProgress = false;
        }, animationDuration);
    }
}
